import { get } from 'lodash';
import { config } from 'api';
import { BetaFeatures as FoodProfileBetaFeatures } from 'apps/foodProfile/consts';
import errorHandler from 'lib/utils/errorHandler';
import { fetchProductsSuitability } from 'apps/foodProfile/actions/foodProfile';

export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const ADD_AWAIT_PRODUCTS = 'ADD_AWAIT_PRODUCTS';

/**
 * Adds the given products array to the repository
 *
 * @param products array
 * @returns {{type: string, products: *}}
 */
export function addProducts(products) {
  return (dispatch, getState) => {
    const isFoodMaestroEnabled = get(getState(), 'user.betaFeatures', [])
      .includes(FoodProfileBetaFeatures.FOODMAESTRO_ENABLED);
    dispatch({
      type: ADD_PRODUCTS,
      products,
    });
    if (isFoodMaestroEnabled) dispatch(fetchProductsSuitability(products.map(product => product.gtin)));
  };
}

/**
 * Adds the given products array to the repository (awaiting array)
 *
 * @param skus array
 * @returns {{type: string, products: *}}
 */
export function addAwaitProducts(skus) {
  return {
    type: ADD_AWAIT_PRODUCTS,
    skus,
  };
}

// visible for tests
export function filterOutCachedAndPendingProducts(productsToFetch, productsInCache) {
  return productsToFetch
    .filter(p =>
      !productsInCache[p.sku] // check if product in cache
      || (p.hash && productsInCache[p.sku].hash !== p.hash) // check if up to date (hash match)
    )
    .map(p => p.sku);
}

/**
 * Checks whether the requested products exist in cache and if not, fetch it from the server.
 * May be called multiple times with same sku-and-hash data, ensuring each product will be requested from the server
 * only once.
 *
 * @param productsToFetch array of sku-and-hash identifiers, e.g. [{sku: 12345, hash: 67890}] (hash is optional)
 * @returns {function(*, *)}
 */
export function ensureProducts(productsToFetch) {
  return (dispatch, getState, { network }) => {
    const { awaitProductsBySku, productsBySku } = getState().products;
    let skusToFetch = filterOutCachedAndPendingProducts(productsToFetch, productsBySku);

    // Remove SKUs for which we have requested already
    skusToFetch = skusToFetch.filter(sku => awaitProductsBySku.indexOf(sku) === -1);

    if (skusToFetch.length) {
      dispatch(addAwaitProducts(skusToFetch));

      return network.get(`${config.apiBasePath}/products?skus=${skusToFetch.join(',')}`)
        .then(data => dispatch(addProducts(data)))
        .catch(errorHandler);
    }
    return Promise.resolve();
  };
}
